"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.section-banner-slider-1-5').each(function (index, element) {
    var tagArrowLeft = (0, _jquery2.default)(element).data('tag-arrow-left');
    var tagArrowRight = (0, _jquery2.default)(element).data('tag-arrow-right');
    (0, _jquery2.default)(element).slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      //prevArrow: "<button class='slick-next slick-arrow button-arrow button-arrow-prev' aria-label='Previous' type='button' style=''><div class='arrow'></div>Previous</button>",
      //nextArrow: "<button class='slick-prev slick-arrow button-arrow button-arrow-next' aria-label='Next' type='button' style=''><div class='arrow'></div>Next</button>",
      //appendArrows: $('.container-arrows-banner-2', $(element).closest('.row')),
      appendDots: (0, _jquery2.default)('.container-dots', (0, _jquery2.default)(element).closest('.row'))
      //prevArrow: $('.button-arrow-prev', $(element).closest('.row')),
      //nextArrow: $('.button-arrow-next', $(element).closest('.row')),
    });

    (0, _jquery2.default)(element).on('init', function (event, slick, direction) {
      (0, _jquery2.default)('.slick-slide a', (0, _jquery2.default)(element)).each(function (index2, element2) {
        var id = (0, _jquery2.default)(element2).data('id');
        (0, _jquery2.default)(element2).attr('id', id);
      });
    });
  });
});